import styled from 'styled-components';

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
`;
export const Counts = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  color: ${(props) => props.theme.colors.onSurface};
`;
export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const Card = styled.article<{ $status: string }>`
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.onSurfaceLight};
  border-left: 4px solid ${(props) => (
    props.$status === 'approved' ? props.theme.colors.positive
      : props.$status === 'rejected' ? props.theme.colors.negative : props.theme.colors.warning
  )};
  background: ${(props) => props.theme.colors.surface};
  color: ${(props) => props.theme.colors.onSurface};
  h3 { margin: 0.5rem 0; font-size: 1rem; }
  p { white-space: pre-wrap; overflow-wrap: anywhere; }
`;
export const NoteInput = styled.textarea`
  width: 100%;
  min-height: 80px;
  box-sizing: border-box;
  resize: vertical;
  background: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.onSurface};
  border: 1px solid ${(props) => props.theme.colors.onSurfaceLight};
`;
export const GeneralNoteContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  color: ${(props) => props.theme.colors.onSurface};
  p { margin: 0; }
`;
export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.85rem;
`;
export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;
export const Action = styled.button<{ $tone?: 'positive' | 'negative' }>`
  cursor: pointer;
  padding: 0.55rem 0.9rem;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.onSurfaceLight};
  background: ${(props) => props.$tone ? props.theme.colors[props.$tone] : props.theme.colors.surface};
  color: ${(props) => props.$tone ? '#fff' : props.theme.colors.onSurface};
  font-weight: 600;
  &:disabled { cursor: default; opacity: 0.5; }
`;
export const Hint = styled.p`
  font-size: 0.85rem;
  margin: 0.5rem 0;
`;
